import React, { useEffect } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { useLocation } from "react-router-dom";

import { WSTabs } from "../../../Components/Tabs/WSTabs";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import Inventory2Icon from '@mui/icons-material/Inventory2';


import { StockinList } from "./StockinList";
import { StockoutList } from "./StockoutList";
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";

const StockentryList = () => {
  const location = useLocation();
  const initialTab = (location.state as { activeTab?: number } | null)?.activeTab ?? 0;

  const { control, setValue } = useForm({
    defaultValues: {
      stockTab: initialTab, // default = Stock In (unless navigated with activeTab state)
    },
  });

  useEffect(() => {
    updateMainHeader("Inventory");
    labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
  }, []);

  useEffect(() => {
    const tab = (location.state as { activeTab?: number } | null)?.activeTab;
    if (typeof tab === "number") {
      setValue("stockTab", tab);
    }
  }, [location.state, setValue]);

  const tabs = [
    {
      label: "Stock In",
      content: <StockinList />,
    },
    {
      label: "Stock Out",
      content: <StockoutList />,
    },
  ];

  return (
    <Grid p={3}>
      {/* <Typography sx={{ fontSize: "22px", fontWeight: 600, mb: 2 }}>
        Stock Entry
      </Typography> */}

      {}
      <Box
        sx={{

          p: "-20px",
          borderRadius: "2",

          width: "100%", // ✅ FULL WIDTH
          mb: 2,
        }}
      >
        <WSTabs
          name="stockTab"
          control={control}
          setValue={setValue}
          tabs={tabs}
          id=""
        />
      </Box>
    </Grid>
  );
};

export default StockentryList;